import { SearchViewModel } from '@api/v3';
import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import { DateType } from '@utils/dateUtil';

export interface SearchBarProps {
  location: SearchViewModel;
  setLocation: React.Dispatch<React.SetStateAction<SearchViewModel>>;
  startDate: DateType | null;
  endDate: DateType | null;
  setDates: React.Dispatch<
    React.SetStateAction<{
      startDate: DateType | null;
      endDate: DateType | null;
    }>
  >;
  hotelRoomsList: Array<ListingSearchRoomInterface>;
  setHotelRoomsList: React.Dispatch<
    React.SetStateAction<ListingSearchRoomInterface[]>
  >;

  isStickySearch?: boolean;

  isLocationEntered: boolean;
  setIsLocationEntered: React.Dispatch<React.SetStateAction<boolean>>;

  locationInputVal: string;
  setLocationInputVal: React.Dispatch<React.SetStateAction<string>>;

  initialHotelRooms: Array<ListingSearchRoomInterface>;
  setInitialHotelRooms: React.Dispatch<
    React.SetStateAction<Array<ListingSearchRoomInterface>>
  >;
  setIsDateSelected?: React.Dispatch<React.SetStateAction<boolean>>;

  isDateSelected?: boolean;
  onResearchClick?: () => void;

  isHotelListing?: boolean;
  packageTabChanged?: boolean;
}

export const PACKAGE_MAX_AGE = 12;
